module.exports = __webpack_public_path__ + "img/PAI_Landing-Page_Mobile_05.3477b2c4.jpg";